import { Stack } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { BottomSheet, Text, type UseModalState } from "@src/appV2/redesign/system/ui-components";

import { InHomeOpenVisitCard } from "../OpenVisits/Card";
import { type PatientData, type VisitWithCaseData } from "../types";

interface VisitsAtLocationDrawerProps {
  modalState: UseModalState;
  visits: VisitWithCaseData[];
  caseIdToPatientMap: Map<string, PatientData>;
  caseIdToSpecialtiesMap: Map<string, string[]>;
  caseIdToWorkplaceNameMap: Map<string, string>;
  caseIdToWorkplaceIdMap: Map<string, string>;
}

export function VisitsAtLocationDrawer(props: VisitsAtLocationDrawerProps) {
  const {
    modalState,
    visits,
    caseIdToPatientMap,
    caseIdToSpecialtiesMap,
    caseIdToWorkplaceNameMap,
    caseIdToWorkplaceIdMap,
  } = props;

  return (
    <BottomSheet
      modalState={modalState}
      header={
        <BottomSheetHeader onClose={modalState.closeModal}>
          <Text semibold variant="h4">
            {visits.length} {visits.length === 1 ? "visit" : "visits"} near this location
          </Text>
        </BottomSheetHeader>
      }
      paperSx={{ maxHeight: "70vh" }}
    >
      <Stack spacing={5} sx={{ px: 5, pb: 5, overflow: "auto" }}>
        {visits.map((visit) => {
          const patient = caseIdToPatientMap.get(visit.attributes.caseId);
          const specialties = caseIdToSpecialtiesMap.get(visit.attributes.caseId);
          const workplaceName = caseIdToWorkplaceNameMap.get(visit.attributes.caseId);
          const workplaceId = caseIdToWorkplaceIdMap.get(visit.attributes.caseId);

          return (
            <InHomeOpenVisitCard
              key={visit.id}
              visit={visit}
              patient={patient}
              specialties={specialties ?? []}
              workplaceName={workplaceName ?? ""}
              workplaceId={workplaceId ?? ""}
            />
          );
        })}
      </Stack>
    </BottomSheet>
  );
}
